import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import * as marksetSegmentsApi from '../api/market_segments';
import { canEditMarketSegments, reactListTablesEnabled } from '../permissions';
import { translate } from '../i18n_text';
import { session } from '../session';
import { GridView } from '../utils/grid_view';
import { ListHeaderAction } from '../components/list_header';
import i18n from '../i18n';
import { NamesListPage, NamesListProps, NamesListQuery, NamesListRow } from 'react-islands';

let template = require('raw-loader!../../templates/market_segments.html').default;

class MarketSegmentsScreen
  implements ListLoaderDelegate<marksetSegmentsApi.MarketSegmentData, marksetSegmentsApi.MarketSegmentData>
{
  canAdd = canEditMarketSegments();

  listActions: ListHeaderAction[] = this.canAdd
    ? [{ title: i18n.t('Add')(), icon: 'add_circle', href: '/market_segments/new/' }]
    : [];

  newMarketSegmentsTable = reactListTablesEnabled();

  private view = new GridView('market-segments');

  tableProps = ko.pureComputed<NamesListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
    exportFileName: 'market-segments',
  }));

  constructor(params: { filters: unknown }) {
    if (this.newMarketSegmentsTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return marksetSegmentsApi.list(params);
  }

  private fetchPage = (query: NamesListQuery): Promise<NamesListPage> =>
    this.view.fetchListPage(query, marksetSegmentsApi.list, 'name_prefix', this);

  toRow = (data: marksetSegmentsApi.MarketSegmentData): NamesListRow => ({
    id: data.id || '',
    name: translate(data.name_json),
    url: session.toTenantPath(`/market_segments/${data.id}/`),
    actions: delegateActions(this, data, this.view.reload),
  });

  instantiate(data: marksetSegmentsApi.MarketSegmentData) {
    return data;
  }

  remove(id: string) {
    return marksetSegmentsApi.remove(id);
  }

  canRemove(data: marksetSegmentsApi.MarketSegmentData) {
    return canEditMarketSegments();
  }
}

export let marketSegments = {
  name: 'market-segments',
  viewModel: MarketSegmentsScreen,
  template: template,
};

ko.components.register(marketSegments.name, marketSegments);
